import { Button, Card, Col, Stack } from "react-bootstrap";
import { Dash, PauseFill, PlayFill, Plus } from "react-bootstrap-icons";
import { decreasePlaybackSpeed, increasePlaybackSpeed, toggleAudioPlay } from "./clocksFunctions";
import { formatTime } from "../HelperFunctions";
import ClocksAudioPlayer from "./ClocksAudioPlayer";

const buttonStyle = "p-0 d-flex btn-ra-yellow border-0";
const iconSize = { height: 25, width: 25 };

export default function ClocksAudioCard({
    data,
    isAudioAvailable,
    isPlaying,
    setIsPlaying,
    audioRef,
    setPlaybackRate,
    playbackRate,
    currentAudioTime,
    setCurrentAudioTime,
    setIsAudioAvailable,
    refreshCounter,
    markInSeconds,
    markOutSeconds,
}) {
    return (
        <>
            <ClocksAudioPlayer
                audioDelay={data.audio_delay}
                audioUrl={data.audio_url}
                audioRef={audioRef}
                setCurrentAudioTime={setCurrentAudioTime}
                startAudioTime={currentAudioTime}
                setIsAudioAvailable={setIsAudioAvailable}
                refreshCounter={refreshCounter}
            />
            <Card>
                <Card.Header className="fs-7">Audio{!isAudioAvailable && " (Unavailable)"}</Card.Header>
                <Card.Body className="p-1">
                    <Stack direction="horizontal">
                        <Col>
                            <Stack>
                                <Stack direction="horizontal" gap={1} className="fw-bold fs-7 text-center justify-content-center">
                                    <Button
                                        size="sm"
                                        className={buttonStyle}
                                        disabled={!isAudioAvailable}
                                        onClick={() => decreasePlaybackSpeed(audioRef.current, setPlaybackRate, isAudioAvailable)}>
                                        <Dash {...iconSize} />
                                    </Button>
                                    <span>{playbackRate.toFixed(2)}x</span>
                                    <Button
                                        size="sm"
                                        className={buttonStyle}
                                        disabled={!isAudioAvailable}
                                        onClick={() => increasePlaybackSpeed(audioRef.current, setPlaybackRate, isAudioAvailable)}>
                                        <Plus {...iconSize} />
                                    </Button>
                                </Stack>
                            </Stack>
                        </Col>
                        <div className="vr"></div>
                        <Col>
                            <Stack>
                                <Stack direction="horizontal" gap={1} className="fw-bold text-center justify-content-center">
                                    <span className="fs-7 text-center text-nowrap">{formatTime(currentAudioTime)}</span>
                                    <Button
                                        size="sm"
                                        className={buttonStyle}
                                        disabled={!isAudioAvailable}
                                        onClick={() => toggleAudioPlay(audioRef.current, setIsPlaying, isAudioAvailable)}>
                                        {isPlaying ? <PauseFill {...iconSize} /> : <PlayFill {...iconSize} />}
                                    </Button>
                                </Stack>
                            </Stack>
                        </Col>
                    </Stack>
                    {markInSeconds > 0 && markOutSeconds > 0 && (
                        <Stack direction="horizontal" className="fs-7 justify-content-center mt-1" gap={2}>
                            <span>Selection:</span>
                            <span className=" fw-bold">
                                {formatTime(Math.round(markInSeconds))} - {formatTime(Math.round(markOutSeconds))}
                            </span>
                            <span>({formatTime(Math.round(markOutSeconds - markInSeconds))})</span>
                        </Stack>
                    )}
                </Card.Body>
            </Card>
        </>
    );
}
